// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"ccf9e431","581":"121d4fdd"}[chunkId] + ".chunk.js";
};